/**
 * Libellés français partagés entre la liste (`CompteCommandesPage`) et le
 * détail (`CompteCommandeDetailPage`) — porté à l'identique depuis
 * apps/web/app/(account)/compte/commandes/order-format.ts (aucune dépendance
 * Next.js dans l'original), alignés sur les enums Prisma réels
 * (packages/db/prisma/schema.prisma `OrderStatus`/`PaymentStatus`), pas devinés.
 */

export const ORDER_STATUS_LABELS: Record<string, string> = {
  DRAFT: "Brouillon",
  PENDING_CONFIRMATION: "En attente de confirmation",
  CONFIRMED: "Confirmée",
  AWAITING_PAYMENT: "En attente de paiement",
  PAID: "Payée",
  PROCESSING: "En préparation",
  READY_TO_SHIP: "Prête à expédier",
  SHIPPED: "Expédiée",
  DELIVERY_FAILED: "Échec de livraison",
  DELIVERED: "Livrée",
  RETURN_REQUESTED: "Retour demandé",
  RETURNED: "Retournée",
  REFUNDED: "Remboursée",
  COMPLETED: "Terminée",
  CANCELLED: "Annulée",
};

export function orderStatusLabel(status: string): string {
  return ORDER_STATUS_LABELS[status] ?? status;
}

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  UNPAID: "Non payée",
  AUTHORIZED: "Paiement autorisé",
  PAID: "Payée",
  PARTIALLY_REFUNDED: "Partiellement remboursée",
  REFUNDED: "Remboursée",
  FAILED: "Paiement échoué",
};

export function paymentStatusLabel(status: string): string {
  return PAYMENT_STATUS_LABELS[status] ?? status;
}

const DATE_FORMATTER = new Intl.DateTimeFormat("fr-FR", {
  day: "2-digit",
  month: "long",
  year: "numeric",
});

/** @param isoDate Date ISO 8601 telle que renvoyée par apps/api (ex. `order.placedAt`). */
export function formatOrderDate(isoDate: string): string {
  return DATE_FORMATTER.format(new Date(isoDate));
}
